import type { IconProps } from './types';

export const Trash01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M0.75 6.375H23.25M9.1875 11.0625V17.625M14.8125 11.0625V17.625M8.25 6.375V5.4375C8.25 3.36643 9.92893 1.6875 12 1.6875C14.071 1.6875 15.75 3.36643 15.75 5.4375V6.375M3.5625 6.375H20.4375V22.3125H3.5625V6.375Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
